import React, { useState } from 'react';
import { Auth } from 'aws-amplify';

const Login = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      // All authentication now goes through AWS Cognito

      const user = await Auth.signIn(email, password);
        
        // Check if user profile exists in backend, create if needed
        try {
          const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://26hq22qc2l.execute-api.ap-southeast-2.amazonaws.com/prod'}/users/${user.username}`);
          if (!response.ok) {
            // User profile doesn't exist, create it
            await fetch(`${process.env.REACT_APP_API_URL || 'https://26hq22qc2l.execute-api.ap-southeast-2.amazonaws.com/prod'}/users`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                userId: user.username,
                email: user.attributes.email,
                userType: user.attributes['custom:user_type'],
                venueName: user.attributes['custom:venue_name'],
                businessName: user.attributes['custom:business_name'],
                vendorType: user.attributes['custom:vendor_type']
              })
            });
          }
        } catch (error) {
          console.log('Profile check/creation failed, continuing with login');
        }
        
        setMessage('✅ Login successful!');
        if (onLoginSuccess) {
          onLoginSuccess(user);
        }
    } catch (error) {
      setMessage(`❌ Error: ${error.message}`);
    }
    setLoading(false);
  };



  return (
    <div style={{ 
      backgroundColor: '#f8fafc', 
      minHeight: '100vh', 
      fontFamily: 'Georgia, serif',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{ 
        maxWidth: '400px', 
        width: '100%',
        margin: '0 20px',
        padding: '40px',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 16px rgba(0,0,0,0.1)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <img 
            src="/everset-logo.svg" 
            alt="Everset" 
            style={{ height: '40px', width: 'auto', marginBottom: '16px' }}
          />
          <p style={{ color: '#6B7280', fontSize: '16px', margin: 0 }}>
            Plan your perfect wedding
          </p>
        </div>
      
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '20px' }}>
          <label style={{ 
            display: 'block',
            fontSize: '14px',
            fontWeight: '500',
            color: '#374151',
            marginBottom: '6px'
          }}>Username</label>
          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="Enter your username"
            style={{ 
              width: '100%', 
              padding: '12px 16px', 
              border: '1px solid #E5E7EB',
              borderRadius: '8px',
              fontSize: '16px',
              backgroundColor: '#F9FAFB',
              outline: 'none',
              transition: 'border-color 0.2s'
            }}
            onFocus={(e) => e.target.style.borderColor = '#6B9080'}
            onBlur={(e) => e.target.style.borderColor = '#E5E7EB'}
          />
        </div>

        <div style={{ marginBottom: '24px' }}>
          <label style={{ 
            display: 'block',
            fontSize: '14px',
            fontWeight: '500',
            color: '#374151',
            marginBottom: '6px'
          }}>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder="Enter your password"
            style={{ 
              width: '100%', 
              padding: '12px 16px', 
              border: '1px solid #E5E7EB',
              borderRadius: '8px',
              fontSize: '16px',
              backgroundColor: '#F9FAFB',
              outline: 'none',
              transition: 'border-color 0.2s'
            }}
            onFocus={(e) => e.target.style.borderColor = '#6B9080'}
            onBlur={(e) => e.target.style.borderColor = '#E5E7EB'}
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          style={{
            width: '100%',
            padding: '12px 24px',
            backgroundColor: loading ? '#9CA3AF' : '#6B9080',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '500',
            cursor: loading ? 'not-allowed' : 'pointer',
            transition: 'background-color 0.2s'
          }}
          onMouseOver={(e) => !loading && (e.target.style.backgroundColor = '#5A7A6A')}
          onMouseOut={(e) => !loading && (e.target.style.backgroundColor = '#6B9080')}
        >
          {loading ? 'Signing in...' : 'Let\'s Go!'}
        </button>
      </form>



      {/* Sign up toggle temporarily hidden
      {!needsVerification && (
        <p style={{ textAlign: 'center', marginTop: '15px' }}>
          {isSignUp ? 'Already have an account?' : "Don't have an account?"}{' '}
          <button
            onClick={() => setIsSignUp(!isSignUp)}
            style={{
              background: 'none',
              border: 'none',
              color: '#4F46E5',
              cursor: 'pointer',
              textDecoration: 'underline'
            }}
          >
            {isSignUp ? 'Login' : 'Sign Up'}
          </button>
        </p>
      )}
      */}

        {message && (
          <div style={{
            marginTop: '16px',
            padding: '12px 16px',
            backgroundColor: message.includes('❌') ? '#FEF2F2' : '#F0FDF4',
            border: `1px solid ${message.includes('❌') ? '#FECACA' : '#BBF7D0'}`,
            borderRadius: '8px',
            fontSize: '14px',
            color: message.includes('❌') ? '#DC2626' : '#16A34A'
          }}>
            {message}
          </div>
        )}
      </div>






    </div>
  );
};

export default Login;